import { API_URL } from '../config/api';
import { tokenManager } from '../context/AuthContext';

// API client for the Expense module masters (Phase 1).
// Authorization is enforced server-side; the UI only hides what the user can't use.

export const MASTER_ENDPOINTS = {
  countries: '/masters/countries',
  currencies: '/masters/currencies',
  vendors: '/masters/vendors',
  categories: '/expenses/masters/categories',
  heads: '/expenses/masters/heads',
  paidVia: '/expenses/masters/paid-via',
  jobNames: '/expenses/masters/job-names',
};

const request = async (method, path, body) => {
  const response = await fetch(`${API_URL}${path}`, {
    method,
    headers: {
      ...tokenManager.getAuthHeader(),
      'Content-Type': 'application/json',
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });

  let data = null;
  try {
    data = await response.json();
  } catch (e) {
    data = null;
  }

  if (!response.ok) {
    throw new Error(data?.message || `Request failed (${response.status})`);
  }
  return data;
};

const toQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.append(k, String(v));
  });
  const s = qs.toString();
  return s ? `?${s}` : '';
};

export const mastersApi = {
  list: (resource, params) => request('GET', `${MASTER_ENDPOINTS[resource]}${toQuery(params)}`),
  create: (resource, body) => request('POST', MASTER_ENDPOINTS[resource], body),
  update: (resource, id, body) => request('PATCH', `${MASTER_ENDPOINTS[resource]}/${id}`, body),
  setActive: (resource, id, active) => request('PATCH', `${MASTER_ENDPOINTS[resource]}/${id}/active`, { active }),
};

export const employeeSettingsApi = {
  list: (params) => request('GET', `/expenses/employee-settings${toQuery(params)}`),
  get: (employeeId) => request('GET', `/expenses/employee-settings/${employeeId}`),
  save: (employeeId, body) => request('PATCH', `/expenses/employee-settings/${employeeId}`, body),
};

// Active users (minimal fields) - available to any authenticated user
export const fetchActiveUsers = () => request('GET', '/users/public');

export const userLabel = (u) =>
  u ? `${u.firstName || ''} ${u.lastName || ''}`.trim() + (u.email ? ` - ${u.email}` : '') : '';
